export const getObjectId = (fileVersionUrn: string | undefined, viewableGuid: string): string => {
    return btoa(`${fileVersionUrn}_${viewableGuid}` as string);
};
